"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledProductPart = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _get = _interopRequireDefault(require("lodash/get"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _getImageUrl = _interopRequireDefault(require("../../../../Utils/getImageUrl"));
var _customClassName = _interopRequireDefault(require("../../../../Utils/customClassName"));
var _i18n = require("../../../../../Framework/i18n");
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ProductPart = function ProductPart(_ref) {
  var displaySwitchedOptions = _ref.displaySwitchedOptions,
    onSelect = _ref.onSelect,
    optionclassification = _ref.optionclassification,
    selectedOption = _ref.selectedOption,
    verticalMode = _ref.verticalMode,
    setAnchorRef = _ref.setAnchorRef,
    classes = _ref.classes,
    optionListVisible = _ref.optionListVisible,
    onCloseSelected = _ref.onCloseSelected;
  var selected = (0, _get["default"])(selectedOption, 'identifier', null) === (0, _get["default"])(optionclassification, 'identifier', '');
  var selectedAndVisible = optionListVisible && selected;
  var direction = verticalMode ? 'vertical' : 'horizontal';
  (0, _react.useEffect)(function () {
    if (!optionListVisible && selected) {
      onCloseSelected(optionclassification);
    }
  }, [optionListVisible]);
  var displayImage = function displayImage() {
    var imageUrl = displaySwitchedOptions && selectedOption ? (0, _getImageUrl["default"])(selectedOption.thumbnail) : (0, _getImageUrl["default"])(optionclassification.thumbnail);
    return /*#__PURE__*/_react["default"].createElement("i", {
      className: "".concat(classes.icon, " ").concat(direction),
      style: imageUrl ? {
        backgroundImage: 'url(' + imageUrl + ')'
      } : {}
    });
  };
  var displayText = function displayText() {
    return /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      className: classes.rootTypography,
      variant: "body1",
      component: "span"
    }, /*#__PURE__*/_react["default"].createElement(_i18n.Hyphenated, null, optionclassification.title));
  };
  var onClick = function onClick(event) {
    event.stopPropagation();
    onSelect(optionclassification);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(classes.root, direction, (0, _customClassName["default"])('component')),
    ref: setAnchorRef
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.marker, " ").concat(direction, " ").concat(selectedAndVisible ? 'selected' : '')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.content, " ").concat(direction),
    onClick: onClick
  }, displayImage(), displayText()));
};
var MARKER_POSITION = {
  left: 'left',
  right: 'right',
  top: 'top'
};
ProductPart.defaultProps = {
  optionclassification: {},
  onSelect: function onSelect() {},
  verticalMode: true
};
var StyledProductPart = exports.StyledProductPart = (0, _styles.withStyles)(function (theme) {
  var _root, _selected;
  var captionMaxHeight = "calc(".concat(theme.creator.productPart.captionPaddingTop, " + ").concat(theme.creator.productPart.lineHeight, " * 2)");
  var iconMaxHeigth = "calc(".concat(theme.creator.productPart.itemSize, " - ").concat(captionMaxHeight, "  - ").concat(theme.creator.productPart.captionPaddingTop, ")");
  var iconSizeWithoutMarker = "calc(".concat(theme.creator.productPart.itemSize, " - ").concat(theme.creator.productPart.spaceBetweenItemAndMarker, ")");
  var contentMargin = {
    right: '0 0 0 ' + theme.creator.productPart.spaceBetweenItemAndMarker,
    left: '0 ' + theme.creator.productPart.spaceBetweenItemAndMarker + ' 0 0'
  };
  return {
    root: (_root = {}, _defineProperty(_root, theme.breakpoints.up('sm'), {
      width: theme.creator.productPart.selectedItemSize
    }), _defineProperty(_root, "width", theme.creator.productPart.itemSize), _defineProperty(_root, "height", 'auto'), _defineProperty(_root, '&.horizontal', {
      padding: '0 10px'
    }), _defineProperty(_root, '&.vertical', {
      marginLeft: 'auto',
      display: 'flex',
      flexDirection: 'row-reverse'
    }), _defineProperty(_root, "tapHighlightColor", theme.tapHighlightColor), _root),
    content: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      cursor: 'pointer',
      textAlign: 'center',
      position: 'relative',
      '&.horizontal': {
        width: theme.creator.productPart.itemSize,
        height: 'auto',
        "float": MARKER_POSITION.top,
        whiteSpace: 'normal',
        '& span': {
          marginBottom: 0
        }
      },
      '&.vertical': {
        width: iconSizeWithoutMarker,
        maxHeight: 120,
        "float": theme.creator.productPartsList.markerVerticalPosition,
        margin: theme.creator.productPartsList.markerVerticalPosition === MARKER_POSITION.right ? contentMargin.left : contentMargin.right
      }
    },
    icon: {
      maxHeight: iconMaxHeigth,
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      display: 'block',
      '&.horizontal': {
        width: theme.creator.productPart.itemSize,
        height: 'calc(0.75*' + theme.creator.productPart.itemSize + ')'
      },
      '&.vertical': {
        width: iconSizeWithoutMarker,
        height: 'calc(0.75*' + iconSizeWithoutMarker + ')'
      }
    },
    marker: {
      backgroundColor: 'transparent',
      '&.horizontal': {
        width: theme.creator.productPart.itemSize,
        height: theme.creator.productPart.markerThickness
      },
      '&.vertical': {
        width: theme.creator.productPart.markerThickness,
        height: "calc(".concat(theme.creator.productPart.itemSize, " - 24px)"),
        "float": theme.creator.productPartsList.markerVerticalPosition
      },
      '&.selected': (_selected = {}, _defineProperty(_selected, theme.breakpoints.down('sm'), {
        marginBottom: 4
      }), _defineProperty(_selected, "backgroundColor", theme.palette.primary.main), _selected)
    },
    rootTypography: {
      padding: '3px 0 2px 7px',
      marginBottom: 5,
      display: '-webkit-box',
      overflow: 'hidden',
      wordWrap: 'break-word',
      maxWidth: theme.creator.productPart.itemSize,
      lineHeight: 1,
      boxOrient: 'vertical',
      lineClamp: 3,
      minHeight: 20
    }
  };
}, {
  name: 'ProductPart'
})(ProductPart);
var _default = exports["default"] = StyledProductPart;